// compatibility for CustomEvent in Node 16 and 18
// todo should be removed in 2026 ...
// https://stackoverflow.com/questions/69791262/how-do-i-send-a-customevent-via-a-node-16-eventtarget
export class CustomEvent extends Event {
    constructor(message, data) {
        super(message, data);
        this.detail = data.detail;
    }
}
//# sourceMappingURL=CustomEvent.js.map